import React, { FC } from 'react'
import clsx from 'clsx'

import styles from './Branding.module.scss'
import { StandardProps } from '../../types/common'
import logo from './logo.svg'

interface BrandingProps extends StandardProps {
  /**
   * Source file location
   */
  src?: string
  /**
   * Alt text for image
   */
  alt?: string
  /**
   * Type of logo: one of affiliate, partner, club, or default
   */
  type?: 'affiliate' | 'partner' | 'club' | 'default'
  size?: 'medium' | 'large'
  href?: string
}

export const Branding: FC<BrandingProps> = ({
  className,
  style,
  src,
  alt,
  type = 'default',
  size = 'medium',
  href = '/',
  testid = 'branding',
}) => {
  return (
    <div
      className={clsx({ [styles.large]: size === 'large' }, className)}
      style={style}
      data-testid={testid}
    >
      <a
        href={href}
        className={clsx(styles['hds-branding__logo'], {
          [styles.expresslink]: type === 'affiliate',
        })}
      >
        {src && alt ? (
          <img src={src} alt={alt} />
        ) : (
          <img src={logo} alt='Hagerty Logo' />
        )}
      </a>
    </div>
  )
}
